import { useState } from "react";
import { DEFAULT_PAGE_BANNER } from "./usePageBanner";

type Props = {
  src: string | null;
  fallback: string;
  className: string;
  decoding?: "async" | "sync" | "auto";
};

const PageBannerImage = ({ src, fallback, className, decoding }: Props) => {
  const [current, setCurrent] = useState(src);
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <span className="ac-page-banner-placeholder" aria-hidden="true">
        {!loaded && <span className="ac-page-banner-placeholder__line" />}
      </span>
      {current && (
        <img
          className={`${className} ac-page-banner-image`}
          src={current}
          alt=""
          decoding={decoding}
          style={{ opacity: loaded ? 1 : 0 }}
          onLoad={() => {
            setLoaded(true);
          }}
          onError={() => {
            const next = current !== fallback ? fallback : DEFAULT_PAGE_BANNER;
            if (current !== next) {
              setCurrent(next);
              setLoaded(false);
            }
          }}
        />
      )}
    </>
  );
};

export default PageBannerImage;
